<template>
  <v-navigation-drawer v-model="drawer" right temporary fixed width="300">
    <v-card flat class="pa-5">
      <v-row class="ml-3 pl-1 text-center">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <v-avatar :size="100" class="grey lighten-4 mb-3 outlined">
            <img v-if="user.image" :src="user.image.url.logo" alt="avatar" />
            <img
              v-else
              :src="
                current_user && current_user.foto
                  ? current_user.foto
                  : current_user && current_user.kelamin == 'P'
                  ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                  : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
              "
              alt="avatar"
            />
          </v-avatar>
          <p class="subtitle primary--text mb-0 font-weight-bold">{{ user.name }}</p>
          <p class="caption mb-0 grey--text">{{ user.email }}</p>
        </v-col>
      </v-row>

      <v-list dense></v-list>

      <v-list class="mt-0 pt-0" v-if="isCan('kelas-read')">
        <v-list-item class="grey--text" @click="switchRole">
          <v-list-item-action class="primary2 rounded-lg">
            <v-icon class="ma-1 primary--text">mdi-swap-horizontal</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <span class="caption grey--text">Hak Akses</span>
            <v-list-item-title style="white-space: normal">{{ peran ? peran : "Admin" }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-5"></v-divider>

      <v-list>
        <v-list-item v-if="current_user && current_user.is_super_admin && false" class="grey--text" @click="toRiwayatPesertaPPPK">
          <v-list-item-content>
            <v-list-item-title>Riwayat Peserta PPPK</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="secondary2 rounded-lg">
            <v-icon class="ma-3 secondary--text">mdi-history</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item class="grey--text" @click="logout">
          <v-list-item-content>
            <v-list-item-title>Keluar</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="secondary2 rounded-lg">
            <v-icon class="ma-3 secondary--text">mdi-logout-variant</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <PilihDialog ref="dlgInstansi" />
  </v-navigation-drawer>
</template>

<script>
import { BASE_API } from "@/const";
import PilihDialog from "@/modules/instansi/components/PilihInstansiDialog";

// @group Global Component
export default {
  components: { PilihDialog },
  data() {
    return {
      darkMode: false,
      drawer: false,
    };
  },
  computed: {
    rDrawer() {
      return this.$store.getters["main/rDrawer"];
    },
    roles() {
      return this.$store.getters["user/roles"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    peran() {
      return this.$store.getters["user/currentRole"];
    },
  },
  methods: {
    pilihInstansi() {
      this.$refs.dlgInstansi
        .open()

        .then((res) => res)
        .catch((e) => e);
    },

    toHome() {
      this.$router.push({
        name: "instansi.pilih",
      });
    },
    switchRole() {
      this.$confirm(
        `Silakan pilih Peran`,
        {
          role: this.$store.getters["user/roles"],
        },
        "Pilih Peran"
      )
        .then((res) => {
          return this.$store
            .dispatch("user/getPermissionByRole", {
              instansi_id: this.instansi_id,
              peran_id: res.role.id,
            })
            .then(() => {
              this.$router.push({
                name: "beranda.admin",
              });
            })
            .catch((e) => e);
        })
        .catch((e) => e);
    },
    logout() {
      this.drawer = false;

      window.location.href = `${BASE_API}/logoutcas`;
    },
    toRiwayatPesertaPPPK() {
      this.$router.push({
        name: "user.search.pppk",
      });
    },
  },
  watch: {
    rDrawer(n) {
      this.drawer = n;
    },
    drawer(n) {
      this.$store.commit("main/setRDrawer", n);
    },
  },
};
</script>

<style></style>
